import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setMedicationAdministeredRouteOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getMedicationAdministeredRouteOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const routeResponse: IOptionsResponse = yield call([optionsService, optionsService.getRouteOptions])
    const { entity } = routeResponse
    yield put(setMedicationAdministeredRouteOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRoute() error: ${e}`))
  }
}

export function* getMedicationAdministeredRouteOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getMedicationAdministeredRouteOptions)
}
